import { render, staticRenderFns } from "./template.vue?vue&type=template&id=4dbf104f&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=4dbf104f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf104f",
  null
  
)

export default component.exports